export default {
  CREATE_SUPERADMIN_VIDEO_VOUCHERS_REQUEST:
    "CREATE_SUPERADMIN_VIDEO_VOUCHERS_REQUEST",
  CREATE_SUPERADMIN_VIDEO_VOUCHERS_SUCCESS:
    "CREATE_SUPERADMIN_VIDEO_VOUCHERS_SUCCESS",
  CREATE_SUPERADMIN_VIDEO_VOUCHERS_FAIL:
    "CREATE_SUPERADMIN_VIDEO_VOUCHERS_FAIL",
  //get all VIDEOs
  GET_SUPERADMIN_VIDEOS_REQUEST: "GET_SUPERADMIN_VIDEOS_REQUEST",
  GET_SUPERADMIN_VIDEOS_SUCCESS: "GET_SUPERADMIN_VIDEOS_SUCCESS",
  GET_SUPERADMIN_VIDEOS_FAIL: "GET_SUPERADMIN_VIDEOS_FAIL",

  //edit VIDEOs
  EDIT_SUPERADMIN_VIDEO_REQUEST: "EDIT_SUPERADMIN_VIDEO_REQUEST",
  EDIT_SUPERADMIN_VIDEO_SUCCESS: "EDIT_SUPERADMIN_VIDEO_SUCCESS",
  EDIT_SUPERADMIN_VIDEO_FAIL: "EDIT_SUPERADMIN_VIDEO_FAIL",

  SUSPEND_SUPERADMIN_VIDEO_REQUEST: "SUSPEND_SUPERADMIN_VIDEO_REQUEST",
  SUSPEND_SUPERADMIN_VIDEO_SUCCESS: "SUSPEND_SUPERADMIN_VIDEO_SUCCESS",
  SUSPEND_SUPERADMIN_VIDEO_FAIL: "SUSPEND_SUPERADMIN_VIDEO_FAIL",

  //create VIDEO
  CREATE_SUPERADMIN_VIDEO_REQUEST: "CREATE_SUPERADMIN_VIDEO_REQUEST",
  CREATE_SUPERADMIN_VIDEO_SUCCESS: "CREATE_SUPERADMIN_VIDEO_SUCCESS",
  CREATE_SUPERADMIN_VIDEO_FAIL: "CREATE_SUPERADMIN_VIDEO_FAIL",
  //create VIDEO files
  ADD_SUPERADMIN_VIDEO_FILES_REQUEST: "ADD_SUPERADMIN_VIDEO_FILES_REQUEST",
  ADD_SUPERADMIN_VIDEO_FILES_SUCCESS: "ADD_SUPERADMIN_VIDEO_FILES_SUCCESS",
  ADD_SUPERADMIN_VIDEO_FILES_FAIL: "ADD_SUPERADMIN_VIDEO_FILES_FAIL",

  DELETE_SUPERADMIN_VIDEO_FILES_REQUEST:
    "DELETE_SUPERADMIN_VIDEO_FILES_REQUEST",
  DELETE_SUPERADMIN_VIDEO_FILES_SUCCESS:
    "DELETE_SUPERADMIN_VIDEO_FILES_SUCCESS",
  DELETE_SUPERADMIN_VIDEO_FILES_FAIL: "DELETE_SUPERADMIN_VIDEO_FILES_FAIL",

  DELETE_SUPERADMIN_VIDEO_REQUEST: "DELETE_SUPERADMIN_VIDEO_REQUEST",
  DELETE_SUPERADMIN_VIDEO_SUCCESS: "DELETE_SUPERADMIN_VIDEO_SUCCESS",
  DELETE_SUPERADMIN_VIDEO_FAIL: "DELETE_SUPERADMIN_VIDEO_FAIL",

  GET_SUPERADMIN_VIDEO_REQUEST: "GET_SUPERADMIN_VIDEO_REQUEST",
  GET_SUPERADMIN_VIDEO_SUCCESS: "GET_SUPERADMIN_VIDEO_SUCCESS",
  GET_SUPERADMIN_VIDEO_FAIL: "GET_SUPERADMIN_VIDEO_FAIL",

  GET_PAYMENT_SUBJECT_REQUEST: "GET_PAYMENT_SUBJECT_REQUEST",
  GET_PAYMENT_SUBJECT_SUCCESS: "GET_PAYMENT_SUBJECT_SUCCESS",
  GET_PAYMENT_SUBJECT_FAIL: "GET_PAYMENT_SUBJECT_FAIL",
  SUPERADMIN_GET_COURSE_VIDEOS_REQUEST: "SUPERADMIN_GET_COURSE_VIDEOS_REQUEST",
  SUPERADMIN_GET_COURSE_VIDEOS_SUCCESS: "SUPERADMIN_GET_COURSE_VIDEOS_SUCCESS",
  SUPERADMIN_GET_COURSE_VIDEOS_FAIL: "SUPERADMIN_GET_COURSE_VIDEOS_FAIL",

  //loading
  ADD_SUPERADMIN_VIDEOS_LOADING: "ADD_SUPERADMIN_VIDEOS_LOADING",
};
